module.exports = __webpack_public_path__ + "static/copper-ore-420b5eb0656327ae7e50c8c22af8abd6.png";